/* istanbul ignore file */
type NodePayload = boolean | string | number;

export interface GenericValidation {
    minValue?: number | string;
    minValueMessage?: string;
    maxValue?: number | string;
    maxValueMessage?: string;
    baseValue?: number | string;
    baseValueMessage?: string;
    negativeValueMessage?: string;
    invalidAmountMessage?: string;
    defaultErrorMessage?: string;
}

export const getValidationMessage = (
    validations: GenericValidation,
    value: NodePayload,
): string => {
    if (!validations) {
        return '';
    }

    const {
        defaultErrorMessage,
        negativeValueMessage,
        invalidAmountMessage,
        baseValue,
        baseValueMessage,
        minValue,
        minValueMessage,
        maxValue,
        maxValueMessage,
    } = validations;

    const parsedValue = typeof value === 'string' ? parseFloat(value) : value as number;

    if (defaultErrorMessage && !value && parsedValue !== 0) {
        return defaultErrorMessage;
    }
    if ((invalidAmountMessage || negativeValueMessage || minValueMessage || baseValueMessage || maxValueMessage) && Number.isNaN(parsedValue)) {
        return invalidAmountMessage ?? 'Invalid';
    }
    if (negativeValueMessage && parsedValue < 0) {
        return negativeValueMessage;
    }
    if ((baseValue && parsedValue === (typeof baseValue === 'string' ? parseFloat(baseValue) : baseValue))) {
        return baseValueMessage ?? `Confirm amount: ${baseValue}`;
    }
    if (minValue && parsedValue < (typeof minValue === 'string' ? parseFloat(minValue) : minValue)) {
        return minValueMessage ?? `Entered amount is low: ${minValue}`;
    }
    if (maxValue && parsedValue > (typeof maxValue === 'string' ? parseFloat(maxValue) : maxValue)) {
        return maxValueMessage ?? `Entered amount is high: ${maxValue}`;
    }

    return '';
};
